"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var form_1 = require("../form/form");
var icon_1 = require("./../display/icon");
var BurgerMenu = /** @class */ (function (_super) {
    tslib_1.__extends(BurgerMenu, _super);
    function BurgerMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.menuId = props.burgerMenuId || form_1.generateUniqueId(function (u) { return "burger-menu-" + u; });
        return _this;
    }
    BurgerMenu.prototype.toggleMenu = function () {
        if (!this.isOpen) {
            this.openMenu();
        }
        else {
            this.closeMenu();
        }
    };
    BurgerMenu.prototype.closeMenu = function () {
        var mode = this.props.mode || "push";
        if (mode === "push") {
            this.appNode.classList.remove("menu-open");
            this.appNode.classList.remove("menu-push");
        }
        else {
            this.appNode.classList.remove("menu-open");
            this.appNode.classList.remove("menu-slide");
        }
        this.isOpen = false;
        if (this.props.onMenuToggle) {
            this.props.onMenuToggle(this);
        }
    };
    BurgerMenu.prototype.openMenu = function () {
        var mode = this.props.mode || "push";
        if (mode === "push") {
            this.appNode.classList.add("menu-open");
            this.appNode.classList.add("menu-push");
        }
        else {
            this.appNode.classList.add("menu-open");
            this.appNode.classList.add("menu-slide");
        }
        this.isOpen = true;
        if (this.props.onMenuToggle) {
            this.props.onMenuToggle(this);
        }
    };
    BurgerMenu.prototype.componentDidMount = function () {
        var id = this.props.bodyId || "host";
        var appNode = document.getElementById(id);
        this.appNode = appNode;
        if (!appNode) {
            // tslint:disable-next-line:no-console
            console.error("Cannot find document node of " + id);
            return;
        }
    };
    BurgerMenu.prototype.closeNav = function (e, handler) {
        // There is a probably a nicer way to do this, but CBA right now
        if (this.props.closeOnNavigate) {
            handler();
        }
    };
    BurgerMenu.prototype.renderMenu = function () {
        var _this = this;
        var wrapper = this.props.wrappingComponent;
        return React.cloneElement(wrapper || React.createElement(React.Fragment, null), null, React.createElement("div", null,
            this.props.mode === "slide" && React.createElement("div", { className: "burger-blocker", onClick: function () { return _this.closeMenu(); } }),
            React.createElement("nav", { className: "burger-menu" },
                React.createElement("ul", { className: "burger-menu-list" }, React.Children.map(this.props.children, function (c, index) {
                    return (React.createElement("li", { onClick: function (e) { return _this.closeNav(e, function () { return _this.closeMenu(); }); }, key: "nav_item_" + index }, c));
                })))));
    };
    BurgerMenu.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { className: "burger-menu-button" + (this.props.burgerButtonHidden ? " hidden" : ""), onClick: function () { return _this.toggleMenu(); } }, this.props.buttonIcon && React.createElement(icon_1.Icon, { icon: this.props.buttonIcon })),
            ReactDOM.createPortal(this.renderMenu(), document.getElementById(this.props.bodyId || "host"))));
    };
    return BurgerMenu;
}(React.Component));
exports.BurgerMenu = BurgerMenu;
var BurgerMenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(BurgerMenuItem, _super);
    function BurgerMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BurgerMenuItem.prototype.handleClick = function (handler) {
        if (this.props.delayActionMs) {
            window.setTimeout(function () {
                handler();
            }, this.props.delayActionMs);
        }
        else {
            handler();
        }
    };
    BurgerMenuItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, icon = _a.icon, onClick = _a.onClick, style = _a.style, delayActionMs = _a.delayActionMs, active = _a.active, attrs = tslib_1.__rest(_a, ["title", "icon", "onClick", "style", "delayActionMs", "active"]);
        return (React.createElement("div", tslib_1.__assign({}, attrs, { role: "menuitem", className: "burger-menu-item" + (active ? " active" : ""), style: style, "aria-selected": active || false, onClick: function () { return (onClick ? _this.handleClick(onClick) : null); } }),
            icon && React.createElement(icon_1.Icon, { icon: icon }),
            title));
    };
    return BurgerMenuItem;
}(React.Component));
exports.BurgerMenuItem = BurgerMenuItem;
